var App = App || {};

App.TabToAccordion = (function ($) {
    'use strict';

    var $tabs;

    function init() {

        $tabs = $('.tab-to-accordion');

        $tabs.each(function () {
            var $this = $(this);

            $this.on('show.bs.tab', function (e) {
              $this.find($(e.target).attr('href') + ' .collapse').collapse('show');
                e.stopPropagation();
            });

            $this.on('shown.bs.collapse', function (e) {
                var tabId = $(e.target).parent('.tab-pane').attr('aria-labelledby');
                $this.find('#' + tabId).tab('show');
                e.stopPropagation();
            });
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.TabToAccordion.init();
});